





























import { Component, Mixins, Prop } from "vue-property-decorator";
import NotificationItem from "../components/NotificationItem.vue";
import QueryableInterface from "@/interfaces/QueryableInterface";
import NotificationsMixin, {
  SetAsReadParams,
} from "@/mixins/http/Notifications";
import Notification, { Meta } from "@/models/Notifications";
import { RequestData } from "@/store/types/RequestStore";

const requestTag = "reportJobs";

export type Links = {
  first: string;
  last: string;
  prev: string;
  next: string;
  self: string;
};

@Component({
  components: { NotificationItem },
})
export default class NotificationCenter extends Mixins(NotificationsMixin) {
  @Prop({ default: true }) readonly showMore?: boolean;

  notifications: Notification[] = [];
  loading = false;
  loadingNext = false;
  links: Links | null = null;
  page = 1;

  get currentNotifications(): Notification[] {
    if (!this.notifications) return [];
    return this.notifications;
  }

  get reportJobsRequestStatus(): RequestData {
    return this.requestStatus(requestTag);
  }

  get hasNextPage(): boolean {
    if (!this.links) return false;
    return this.links.next != null || false;
  }

  async loadNext() {
    if (this.showMore == false) {
      return;
    }

    this.loadingNext = true;
    this.page++;
    await this.load();
    this.loadingNext = false;
  }

  async load() {
    const params: QueryableInterface = {
      page: { size: "10", number: this.page },
      filter: { status: ["ready", "read"] },
    };
    this.loading = true;
    const notifications = await this.getNotifications(params, requestTag);
    this.links = this.reportJobsRequestStatus.links;
    if (this.page === 1) {
      this.notifications = [...notifications];
    } else {
      this.notifications = [...this.notifications, ...notifications];
    }
    this.loading = false;
  }

  setCurrentToRead() {
    const notificationsIds = this.currentNotifications.map((notification) => {
      return notification.id;
    });

    const params: SetAsReadParams = { notification_ids: notificationsIds };

    if (notificationsIds.length !== 0) {
      this.setNotificationRead(params, requestTag);
    }
  }

  async created() {
    await this.load();
    setTimeout(this.setCurrentToRead, 3000);
  }
}
